import { DetailedHTMLProps, FC, InputHTMLAttributes, Ref, forwardRef } from 'react'
import styled from 'styled-components'

export type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  ref?: Ref<HTMLInputElement>
  inputWidth?: number
  isError?: boolean
}

// eslint-disable-next-line react/display-name
export const Input: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { inputWidth, isError } = props
  return <StyledInput {...props} inputWidth={inputWidth} ref={ref} isError={isError} autoFocus={false} />
})

const StyledInput = styled.input<InputProps>`
  color: #222;
  border: 1px solid ${({ isError }) => (isError ? '#ED7474' : '#cdcdcd')};
  background: ${({ isError }) => (isError ? '#FFF0F0' : '#fff')};
  border-radius: 5px;
  font-size: 4.3vw;
  width: ${({ inputWidth }) => (inputWidth ? `${inputWidth}vw` : '100%')};
  display: block;
  padding: 3vw;
  outline: none;

  @media screen and (min-width: 767px) {
    padding: 10px;
    font-size: 14px;
    width: ${({ inputWidth }) => (inputWidth ? `${inputWidth}%` : '100%')};
    height: 35px;
  }
`
